var render = function render(){var _vm=this,_c=_vm._self._c;return _c('font-awesome-icon',{attrs:{"icon":"exchange-alt"}})
}
var staticRenderFns = []

export { render, staticRenderFns }